<template>
    <el-dropdown>
        <span class="el-dropdown-link"><img :src="'/img/locale-flags/'+getLang+'.png'">{{languages[getLang]}}<i class="el-icon-arrow-down el-icon--right"></i></span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(label, langKey) in languages" :key="langKey" @click.native="setLang(langKey)" v-if="getLang!==langKey"><img :src="'/img/locale-flags/'+langKey+'.png'">{{ label }}</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
    export default {
        name: "ChangeLocale",
        data: () => ({
            languages: {"ru-RU":"Русский","en-US":"English"}
        }),
        computed: {
            getLang() {
                if (this.languages[this.$store.getters.getLang])
                    return this.$store.getters.getLang;

                return 'en-US';
            },
        },
        methods: {
            setLang (lang) {
                this.$i18n.locale=lang;
                this.$store.commit('setLang', lang);
            }
        }
    }
</script>

<style scoped>

</style>